module.exports = __webpack_public_path__ + "static/CH_identity_Black horizontal-f1aec0c6601346602fd7b3375448eb2e.svg";